module.exports = __webpack_public_path__ + "static/arif-hero-a43b39165c22eebe3fd4bf13e983a237.jpg";